'use client'

import { QUERY_ROUTES } from '@/core/constants/routes'
import { useDeleteSearchParam } from '@/core/hooks/use-delete-search-params'
import { updateHistoryState } from '@/core/lib/utils/routing'
import { Modal, ModalBody } from '@/core/ui/atoms/modal'
import { usePathname } from 'next/navigation'
import { useCallback } from 'react'
import { VerificationForm } from './verification'

export const VerificationModal = () => {
  const { searchParams, deleteSearchParam } = useDeleteSearchParam()
  const pathname = usePathname()

  const handleClose = useCallback(() => {
    deleteSearchParam(QUERY_ROUTES.login.name, { clientOnly: true })
  }, [deleteSearchParam])

  const handleSuccess = useCallback(() => {
    const params = new URLSearchParams(searchParams)
    params.set(QUERY_ROUTES.login.name, QUERY_ROUTES.login.value)
    updateHistoryState(`${pathname}?${params.toString()}`, { type: 'replace' })
  }, [pathname, searchParams])

  return (
    <>
      <Modal
        isOpen={
          QUERY_ROUTES.verify.value ===
          searchParams.get(QUERY_ROUTES.verify.name)
        }
        disableBackdropDismiss
        onClose={handleClose}
        size='lg'
        className='max-h-[90%] max-w-lg overflow-y-hidden rounded-2xl sm:max-h-full'
      >
        <ModalBody className='p-6'>
          <VerificationForm onClose={handleClose} onSuccess={handleSuccess} />
        </ModalBody>
      </Modal>
    </>
  )
}
